<template>
  <div class="tabson1" >
    <!--<label >{{queryData.taxReportTime}} </label>
    <label >{{queryData.taxCompanyName}} </label>
    税金申报情况：<label style="color: #5daf34">{{ queryData.taxReportStatus | bspTableFilter({'1':'dict','2':dicts}) }}</label>
    <label style="color: #409EFF">&ensp;{{ queryData.taxPayStatus | bspTableFilter({'1':'dict','2':dicts}) }}</label>-->

<!--    <el-button type="primary" size="small" @click="backToCodeSet()" style="float: right">返回</el-button>-->
    <bsp-table
      :data.sync="list"
      ref="accountTable"
			id="accountTable"
      show-footer
      :ciic-data-filter.sync="listQuery"
      :footer-method="footerMethod"
      :custom-config="{storage: true}"
      @ciic-data-refresh="_getTaxNormalWagesList"
      :showPagination="listQuery.page"
      style="width: 100%"
    >
      <bsp-table-column
        field="A0010001"
        title="工号"

        width="10%">
        <template slot-scope="scope">{{ scope.row.A0010001 }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="empName"
        title="姓名"

        width="10%">
        <template slot-scope="scope">{{ scope.row.empName }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="idCardType"
        filter-type="select"
        title="证照类型"
        width="10%">
        <template slot-scope="scope">{{ scope.row.idCardType  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="idCard"
        label="证照号码"
        width="10%">
        <template slot-scope="scope">{{ scope.row.idCard }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="thisIncome"
        title="本期收入"

        width="10%">
        <template slot-scope="scope">{{ scope.row.thisIncome }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="otherFree"
        title="本期免税收入"

        width="10%">
        <template slot-scope="scope">{{ scope.row.otherFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="endowmentIndvFree"
        title="基本养老保险费"

        width="10%">
        <template slot-scope="scope">{{ scope.row.endowmentIndvFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="medicalIndvFree"
        title="基本医疗保险费"

        width="10%">
        <template slot-scope="scope">{{ scope.row.medicalIndvFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="unemploymentIndvFree"

        title="失业保险费"
        width="10%">
        <template slot-scope="scope">{{ scope.row.unemploymentIndvFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="fundIndvFree"

        title="住房公积金"
        width="10%">
        <template slot-scope="scope">{{ scope.row.fundIndvFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="childEduAdditionalTotal"

        title="累计子女教育"
        width="10%">
        <template slot-scope="scope">{{ scope.row.childEduAdditionalTotal }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="continuingEduAdditionalTotal"

        title="累计继续教育"
        width="10%">
        <template slot-scope="scope">{{ scope.row.continuingEduAdditionalTotal }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="mortgagAdditionalTotal"

        title="累计住房贷款利息"
        width="10%">
        <template slot-scope="scope">{{ scope.row.mortgagAdditionalTotal }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="rentAdditionalTotal"

        title="累计住房租金"
        width="10%">
        <template slot-scope="scope">{{ scope.row.rentAdditionalTotal }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="supportElderlyAdditionalTotal"

        title="累计赡养老人"
        width="10%">
        <template slot-scope="scope">{{ scope.row.supportElderlyAdditionalTotal }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="thisNeedTax"

        title="本期应预扣预缴税额"
        width="10%">
        <template slot-scope="scope">{{ scope.row.thisNeedTax }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="enterpriseAnnuityFree"

        title="企业(职业)年金"
        width="10%">
        <template slot-scope="scope">{{ scope.row.enterpriseAnnuityFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="healthInsuranceFree"

        title="商业健康保险"
        width="10%">
        <template slot-scope="scope">{{ scope.row.healthInsuranceFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="deferredEndowmentFree"

        title="税延养老保险"
        width="10%">
        <template slot-scope="scope">{{ scope.row.deferredEndowmentFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="otherFee"

        title="其他"
        width="10%">
        <template slot-scope="scope">{{ scope.row.otherFee }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="donationFree"

        title="准予扣除的捐赠额"
        width="10%">
        <template slot-scope="scope">{{ scope.row.donationFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="allTaxFreeTotal"

        title="减免税额"
        width="10%">
        <template slot-scope="scope">{{ scope.row.allTaxFreeTotal }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="remarks"

        title="备注"
        width="10%">
        <template slot-scope="scope">{{ scope.row.remarks }}</template>
      </bsp-table-column>

    </bsp-table>


  </div>
</template>
<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {getTaxList,getTaxBatchById,updateTaxBatch,getBatchEmpByIdList,getEmpDetailByIdList,getTaxNormalWagesList} from "@/api/tax/tax";
  import {mapGetters} from 'vuex';
  import XEUtils from 'xe-utils';

  export default {
    name: "tabson1",
    components: { bspTableColumn, bspTable},
    props:{
      currentTab:{
        type:String,
        default:''
      }
    },
    watch: {

    },
    created(){
      this.queryData=this.$route.query
      // console.log(this.batchId)
      this._getTaxNormalWagesList()

    },
    mounted(){

    },
    computed: {
      ...mapGetters([
        'dicts',
        'pms'
      ]),
    },
    data() {
      return {
        sumListCode:[
          'thisIncome',
          'otherFree',
          'endowmentIndvFree',
          'medicalIndvFree',
          'unemploymentIndvFree',
          'fundIndvFree',
          'childEduAdditionalTotal',
          'continuingEduAdditionalTotal',
          'mortgagAdditionalTotal',
          'rentAdditionalTotal',
          'supportElderlyAdditionalTotal',
          'thisNeedTax',
          'enterpriseAnnuityFree',
          'healthInsuranceFree',
          'deferredEndowmentFree',
          'otherFee',
          'donationFree',
          'allTaxFreeTotal'],//需要合计的列信息
        queryData:null,
        list:[],
        listQuery:{
          limit: 20,
          page: 1,
          total: 0,
          batchId:this.$route.query.batchId,
          taxType:this.$route.query.taxType,
          taxMonth:this.$route.query.taxReportTime

        }
      }
    },
    methods:{
      footerMethod ({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {

            /*if(data&&data.length>0){
              let columFiled = column.property;
              let result = XEUtils.every(data,(data)=>{
                return data[columFiled] ===0 || data[columFiled]===null
              })
              if(result){
                this.hiddenColumns.push(columFiled)
              }
            }*/

            if (columnIndex === 3) {
              return '合计'
            }
            if (this.sumListCode.includes(column.property)) {
              return XEUtils.sum(data, column.property)
            }
            return null
          })
        ]
      },
      _getTaxNormalWagesList(){
        getTaxNormalWagesList(this.listQuery).then(res => {
          console.log(res);
          this.listQuery.total = res.data.total
          this.list = res.data.records
        } ).catch((error) => {
          console.log("错误信息"+error)
        })
      },
      backToCodeSet(){
        this.$router.go(-1)
      },
    }

  }
</script>
<style scoped="scoped">
	 #accountTable >>> .vxe-table .vxe-table--header-wrapper{
		 width: 100%;
	 }
</style>
